module.exports = __webpack_public_path__ + "img/puzzle_4.01624929.png";